module.exports = __webpack_public_path__ + "static/media/invite.d3d3c82d.svg";